export const masterTranslation = {
  en: {
    Reports: "Reports",
    "Invoices & Payments": "Invoices & Payments",
    Submissions: "Submissions",
    Companies: "Companies",
    Teams: "Teams",
    Plans: "Plans",
    Settings: "Settings",
    Users: "Users",
    "Super Admin": "Super Admin",
    TsaSettings: "TSA Settings",
    "Hello haatsign": "",
  },
  ar: {
    Reports: "التقارير",
    "Invoices & Payments": "الفواتير والمدفوعات",
    Submissions: "التقديمات",
    Companies: "الشركات",
    Teams: "الفرق",
    Plans: "الخطط",
    Settings: "الإعدادات",
    Users: "المستخدمون",
    "Super Admin": "المشرف العام",
    TsaSettings: "سلطة الخدمة الموثوقة",
    "Hello haatsign": "",
  },
};
